import pyClient from '../PyAPI_Config'

async function getAnimalList(authState: any, container_id: number) {
  return await pyClient(authState)
    .get<any>(`/animal/container/${container_id}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const AnimalService = {
  getAnimalList,
}

export default AnimalService
